export function useCheckFieldsForData(model) {

    let result = false;

    for (const each in model) {

        if (typeof (model[each]) === 'string' && model[each]) {

            result = true;

            // This is to switch the check to boolean, only for the customs model
        } else if(model.hasOwnProperty('customs')) {

            if(model[each]) result = true;

        } else {

            // Must be ddl object
            if(model[each] !== null) {

                if(model[each].value) result = true;
            }
        }
    }

    return result;
}
